<template>
  <div id="app">
      <header class="SiteHeader">
          <div class="SiteHeader__container">
              <router-link class="SiteHeader__logo" to="/" exact>
                  <img class="Icon Icon--logoPicsolve" src='./assets/logo.png' title="Picsolve logo" />
              </router-link>

              <nav class="SiteNav" :class="{ 'is-active': isActive }">
                  <ul>
                      <li class="SiteNav__item">
                        <a href="https://www.pomvom.com/terms" target="_blank" @click.native="toggleNav()">{{ $t("termsAndConditions") }}</a>
                      </li>
                      <li class="SiteNav__item">
                        <a href="https://www.pomvom.com/privacy-policy" target="_blank" @click.native="toggleNav()">{{ $t("privacyPolicy") }}</a>
                      </li>
                      <li class="SiteNav__item">
                        <a href="https://www.pomvom.com/cookie-policy" target="_blank" @click.native="toggleNav()">{{ $t("cookiePolicy") }}</a>
                      </li>
                      <li class="SiteNav__item">
                        <a href="https://support.pomvom.com/hc" target="_blank" @click.native="toggleNav()">{{ $t("contactUs") }}</a>
                      </li>
                  </ul>
              </nav>
              <!--<LocaleSelector @changed="onLanguageChanged"> </LocaleSelector>-->
              <button class="u-jsButton u-mobileOnly SiteHeader__menuButton" :class="{ 'is-active': isActive }" @click="toggleNav()">
                  <span>{{ $t("menu") }}</span>
              </button>
          </div>
      </header>
      <router-view :locale="locale"/>
  </div>
</template>

<script>
import LocaleSelector from './components/LocaleSelector'

export default {
  name: 'App',
  components: {
    LocaleSelector
  },
  data: function () {
    return {
      isActive: false,
      locale: window.i18n.locale
    }
  },
  mounted() {
    console.log(`picsolve.com version ${process.env.VERSION}`);
    this.locale = window.i18n.locale;
  },
  methods: {
    toggleNav: function () {
      this.isActive = !this.isActive
    },
    getPhotos: function () {
      let getPhotosRoute = '/get-photos-here'
      if (this.$route.path === getPhotosRoute) {
        this.$router.go()
      } else {
        this.$router.push('/get-photos-here')
      }
    },
    onLanguageChanged: function(locale) {
      this.locale = locale;
    }
  }
}
</script>

<style lang="scss">
  @import './styles/main';
</style>



// WEBPACK FOOTER //
// src/App.vue